import DaisyController from './daisy.controller';
import routeConfig from './daisy.routes';

const DaisyComponent = {
	templateUrl: 'components/daisy/daisy.html',
	controller: DaisyController,
	$routeConfig: routeConfig,
	bindings: {
		$router: '<'
	},
	$canActivate: DaisyController.$canActivate
};

export default DaisyComponent;
